import { Singleton } from "util";
import BaseService from "./base.service";

@Singleton
class AccountService extends BaseService {
  async createAccount(params) {
    return await this.post("/v1/accounts", params);
  }

  async changePassword(params) {
    return await this.update("/v1/users/reset_password", params);
  }
}

export default AccountService;



// WEBPACK FOOTER //
// ./src/core/service/account.service.js